"use client"
import { useContext } from 'react'
import { NavbarItem } from '@nextui-org/react'
import { Route } from '../../../routers/routes';

import React from 'react'
import MeAvatar from '../users/MeAvatar'
import Link from 'next/link'
import { UserContext } from '../../../contexts/UserContext';
import { translateIt } from '@/data/translations';
import LoginModal from '../authentication/LoginModal';


export default function NavigationMe(props) {
  const { countryId } = props
  const {me, isAuthenticated} = useContext(UserContext)

  return (
    <>
    {isAuthenticated && me ? (
      <>
        <NavbarItem  className="lg:flex">
          <MeAvatar countryId={countryId} me={me} />
        </NavbarItem>
      </>
    ) : (
      <>
      <NavbarItem className="lg:flex text-white text-xs font-bold">
        <LoginModal size="md" countryId={countryId} trigger={
          <div className="cursor-pointer">{translateIt(countryId, "login__login")}</div>
        }/>
      </NavbarItem>
      </>
    )}
    </>
  )
}
